import React, { useState, useEffect } from 'react';
import { SermonStats } from './SermonStats';
import { AnnouncementsSection } from './AnnouncementsSection';
import { AdsSection } from './AdsSection';
import { AccountSetupNudge } from './AccountSetupNudge';
import { useAuth } from '../../hooks/useAuth';
import { supabase } from '../../lib/supabase';

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

export function UserDashboard() {
  const { user } = useAuth();
  const [firstName, setFirstName] = useState<string>('');

  useEffect(() => {
    if (!user) return;
    supabase
      .from('profiles')
      .select('first_name')
      .eq('id', user.id)
      .single()
      .then(({ data }) => {
        if (data?.first_name) setFirstName(data.first_name);
      });
  }, [user]);

  return (
    <div className="p-6 max-w-7xl mx-auto pb-24 md:pb-6">
      <AccountSetupNudge />
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-midnight dark:text-soft-white font-serif">
          {getGreeting()}{firstName ? `, ${firstName}` : ''}.
        </h1>
        <p className="text-sm text-slate dark:text-soft-white/60 mt-1">
          Welcome back — here's your SermonBuild overview.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <SermonStats />
        </div>
        <div className="space-y-6">
          <AnnouncementsSection />
          <AdsSection />
        </div>
      </div>
    </div>
  );
}
